import Dialog from "ui/elements/dialog/Dialog";
import Template from "ui/Template";
import dialogView from "ui/dialogs/progress/progress.handlebars";
import Sse from "ui/helpers/Sse";
import {i18n} from "ui/i18n";

/**
 * @typedef {object} T_ProgressDialogOptions
 * @property {string} title
 */

export default class ProgressDialog extends Dialog {
	constructor(options) {
		super({
			showTitle: false,
			smallWidth: true
		});

		const cont = (new Template(dialogView)).createElement({
			title: options.title || ''
		});

		/**
		 * @type {HTMLMeterElement}
		 */
		this._els.bar = cont.querySelector('.progress__bar');
		this._els.caption = cont.querySelector('.progress__caption');

		this.setContent(cont);
	}

	/**
	 * @param {string} url
	 * @return {Promise<any>}
	 */
	async load(url) {
		let result = null;
		const sse = new Sse({
			url,
			events: {
				progress: (data) => {
					if (!('value' in data)) {
						return;
					}
					this._els.bar.value = data.value * 100;
					this._els.caption.textContent = data.caption;
				}
			}
		});

		try {
			result = await sse.load();
		} catch (e) {
			this.destroy();
			return null;
		}

		this._els.bar.value = 100;
		this._els.caption.textContent = i18n('title.completed');
		this.destroy();

		return result;
	}
}
